import { useState, useCallback } from 'react';
import { beneficio } from '../../../detalleMutuo/models/operacion';
import { selectorTransversal } from '../../../../dtos/selector';
import { getBeneficios } from '../../../detalleMutuo/services/servicesOperacion';
import { getValoresDominio } from '../../../../services/servicesDominio';
import { AxiosResponse } from 'axios';
import { Dominios, StatusCode } from '../../../../utils/enums';
import { ListaMINVU } from '../components/modalListadoMinvu';
import { getListaMinvu } from '../service/servicesComunMINVU';
import { ListResponseDto } from '../../../../dtos/ListResponseDto';

interface UseComunMinvuReturn<T> {
    beneficios: selectorTransversal[];
    estado: selectorTransversal[];
    listaEstado: (dominio: Dominios) => Promise<void>;
    listaBeneficios: () => Promise<void>;
    listaBeneficiosSeguro: () => Promise<void>;
    listadoMinvu: ListaMINVU[];
    getListMinvu: (fechaDesde: string, fechaHasta: string, tipoArchivo: string) => Promise<void>;
    setBeneficios: React.Dispatch<React.SetStateAction<selectorTransversal[]>>;
}

export function useComunMinvu<T = any>(): UseComunMinvuReturn<T> {
    const [beneficios, setBeneficios] = useState<selectorTransversal[]>([]);
    const [estado, setEstado] = useState<selectorTransversal[]>([]);
    const [listadoMinvu, setListadoMinvu] = useState<ListaMINVU[]>([]);

    const listaBeneficiosSeguro = useCallback(async () => {
        const resp :AxiosResponse<ListResponseDto<beneficio>>= await getBeneficios()
        if (resp.status === 200) {
            const data: beneficio[] = await resp.data.items;
            let values: selectorTransversal[] = [];
            data.map((x) => values.push({ value: (x.codigo), label: x.descripcion }));
            values = values.filter(x => x.value === 'DS_01'); 
            values.push({ value: '0', label: 'Otros subsidios' });
            setBeneficios(values);
        }
    }, []);

    const listaBeneficios = useCallback(async () => {
        const resp :AxiosResponse<ListResponseDto<beneficio>> = await getBeneficios()
        if (resp.status === 200) {
            const data: beneficio[] = await resp.data.items;
            let values: selectorTransversal[] = [];
            data.map((x) => values.push({ value: (x.codigo), label: x.descripcion }));
            setBeneficios(values);
        }
    }, []);

    const listaEstado = useCallback(async (dominio: Dominios) => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(dominio)
        if (resp.status !== StatusCode.Ok) return;

        const data: selectorTransversal[] = await resp.data.items;
        setEstado(data);

    }, []);

    const getListMinvu = useCallback(async (fechaDesde: string, fechaHasta: string, tipoArchivo: string) => {
        // This function can be used to fetch the list of MINVU data if needed
        const resp = await getListaMinvu(fechaDesde, fechaHasta, tipoArchivo);
        if (resp.status === StatusCode.Ok) {
            const data: ListaMINVU[] = await resp.data.items;
            setListadoMinvu(data);
        }

    }, []);

    return { beneficios, estado, listadoMinvu, listaBeneficios, listaEstado, getListMinvu, setBeneficios, listaBeneficiosSeguro };
}

